import { Space } from '@sravni/react-design-system';
import { Button } from '@sravni/react-design-system/lib/Button';
import { Card } from '@sravni/react-design-system/lib/Card';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import cn from 'classnames';

import { OrganizationLogos } from '../OrganizationLogos';

import styles from './ApplicationOptionCard.module.scss';

type TApplicationOptionCardProps = {
  logos: string[];
  title: string;
  benefits: string[];
  buttonTitle: string;
  isHighlighted?: boolean;
  isSubmitting?: boolean;
  onButtonClick: () => void;
  category?: string;
};

export const ApplicationOptionCard: FC<TApplicationOptionCardProps> = ({
  logos,
  title,
  benefits,
  buttonTitle,
  isHighlighted,
  isSubmitting = false,
  onButtonClick,
  category,
}) => {
  return (
    <Card
      size={24}
      color={isHighlighted ? 'blue' : undefined}
      className={cn(styles.card, { [styles.highlighted]: isHighlighted })}
      variant="secondary"
    >
      <div className={styles.body}>
        <OrganizationLogos
          logos={logos}
          category={category}
        />
        <Heading level={5}>{title}</Heading>
        <Space
          direction="vertical"
          size={8}
        >
          {benefits.map((benefit) => (
            <Space
              key={benefit}
              direction="horizontal"
              size={16}
            >
              <Text
                size={20}
                className={isHighlighted ? 'h-color-B100' : undefined}
                strong
              >
                •
              </Text>
              <Text size={14}>{benefit}</Text>
            </Space>
          ))}
        </Space>
        <Button
          variant={isHighlighted ? 'primary' : 'secondary'}
          color="dark"
          size={52}
          block
          className={styles.button}
          loading={isSubmitting}
          onClick={onButtonClick}
        >
          {buttonTitle}
        </Button>
      </div>
    </Card>
  );
};
